import React, { useState } from 'react';
import { useRouter } from 'next/router';
import { useDispatch, useSelector } from 'react-redux';
import { useScreenDetector } from '~/src/hooks/useScreenDetector';
import actions from '~/redux/app/actions';
import actionsCommon from '~/redux/common/actions';
import isLoggued from '~/src/lib/isLoggued';
import isInApp from '~/src/lib/isInApp';
import isHandleContact from '~/src/lib/isHandleContact';
import MultiSort from 'multi-sort';
import Drawer from '@mui/material/Drawer';
import getHeaderSpecialInfoHeight from '~/src/lib/getHeaderSpecialInfoHeight';
//import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import PersonIcon from '@mui/icons-material/Person';
import ChatBubbleOutlineOutlinedIcon from '@mui/icons-material/ChatBubbleOutlineOutlined';
import ReceiptIcon from '@mui/icons-material/Receipt';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import MenuIcon from '@mui/icons-material/Menu';
import FlagIcon from '@mui/icons-material/Flag';
import EuroIcon from '@mui/icons-material/Euro';
import HomeIcon from '@mui/icons-material/Home';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import ContactMailIcon from '@mui/icons-material/ContactMail';
import ScheduleOutlinedIcon from '@mui/icons-material/ScheduleOutlined';
import InfoIcon from '@mui/icons-material/Info';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import actionsApp from '~/redux/app/actions';
import { useScrollPosition } from '@n8tb1t/use-scroll-position';
import isHandleRegime from '~/src/lib/common/regime/isHandleRegime';
import isHandleBooking from '~/src/lib/isHandleBooking';
import getPageSlug from '~/src/lib/getPageSlug';
import getVenueName from '~/src/lib/getVenueName';
import translateMsg from '~/src/lib/translateMsg';
import isDisplayMenu from '~/src/lib/isDisplayMenu';
import isIterable from '~/src/lib/isIterable';

const delay = 400;

function App(props) {
    const router = useRouter();
    const [state, setState] = React.useState({
        top: false,
        left: false,
        bottom: false,
        right: false,
    });

    const [status, setStatus] = React.useState(false);

    const { isMobile, isTablet, isDesktop } = useScreenDetector();

    const business = useSelector((state) => state.business);
    const app = useSelector((state) => state.app);
    const lang = useSelector((state) => state.lang);
    const user = useSelector((state) => state.user);
    const headerHeight = useSelector((state) => state.app.headerHeight);
    const orders = useSelector((state) => state.order);

    const [y, setY] = useState(0);
    const dispatch = useDispatch();

    useScrollPosition(({ prevPos, currPos }) => {
        if (prevPos && prevPos.y) {
            setY(prevPos.y);
        }
    }, []);

    if (Object.keys(business).length === 0) {
        return false;
    }

    const toggleDrawer = (event) => {
        event.preventDefault();
        setStatus(!status);
    };

    const isDisplayLanguages = () => {
        //console.log(1111);
        //console.log(business.info.handle_multilang);
        if (business.info && +business.info.handle_multilang === 0) {
            return false;
        }

        let nb = 0;
        if (isIterable(business.languages2)) {
            nb = business.languages2.filter((o) => o.display === 1).length;
        }

        if (nb > 1) {
            return true;
        }
        return false;
    };

    const _displayItemMenu = () => {
        //console.log(business.menusV2);

        if (business.info.handle_menu === 0) {
            return false;
        }

        const hide_display_menus = business.info.configurations.find(
            (conf) => conf.name === 'hide_display_menus',
        );

        if (hide_display_menus && +hide_display_menus.value === 1) {
            return false;
        }

        const menus = business.menusV2.filter(
            (o) =>
                ['website', 'pdf'].includes(o.type) &&
                o.active === 1 &&
                isDisplayMenu(o, user, lang) === true,
        );

        if (menus.length === 0) {
            return false;
        }

        MultiSort(menus, {
            position: 'ASC',
        });

        if (menus.length === 1) {
            return (
                <ListItem
                    button
                    key="menu"
                    onClick={(event) => {
                        event.preventDefault();
                        setTimeout(() => {
                            setState({ ...state, ['right']: false });
                            _redirect(`m/${menus[0].slug}`);
                        }, 300);
                    }}
                >
                    <ListItemIcon>
                        <MenuBookIcon style={{ color: props.color }} />
                    </ListItemIcon>
                    <ListItemText
                        style={{ color: props.color }}
                        primary={translateMsg(
                            'webapp',
                            `pwa_ui__${business.info.label_website_tab}`,
                        )}
                    />
                </ListItem>
            );
        }

        return (
            <>
                <style type="text/css">
                    {`
                    .MuiListItemIcon-root {
                        min-width: 36px;
                    }
                `}
                </style>

                <ListItem button key="menu">
                    <ListItemIcon>
                        <MenuBookIcon style={{ color: props.color }} />
                    </ListItemIcon>
                    <ListItemText
                        style={{ color: props.color }}
                        primary={translateMsg(
                            'webapp',
                            `pwa_ui__${business.info.label_website_tab}`,
                        )}
                    />
                </ListItem>

                {menus.map((menu, index) => {
                    return (
                        <a
                            key={index}
                            onClick={(event) => {
                                event.preventDefault();
                                dispatch(
                                    actionsCommon.setSelectedMenu(menu.id),
                                );
                                setState({ ...state, ['right']: false });

                                if (menu.typeMenu === 'inside') {
                                    dispatch(
                                        actionsCommon.setMenuType('inside'),
                                    );
                                } else if (menu.typeMenu === 'takeaway') {
                                    dispatch(
                                        actionsCommon.setMenuType('takeaway'),
                                    );
                                } else if (menu.typeMenu === 'delivery') {
                                    dispatch(
                                        actionsCommon.setMenuType('delivery'),
                                    );
                                }

                                setTimeout(() => {
                                    _redirect(`m/${menu.slug}`);
                                }, 300);
                            }}
                        >
                            <ListItem
                                button
                                key={menu.id}
                                style={{
                                    paddingLeft: 50,
                                }}
                            >
                                <ListItemText
                                    style={{ color: props.color }}
                                    primary={menu.title}
                                />
                            </ListItem>
                        </a>
                    );
                })}
            </>
        );
    };

    const _displayItemBooking = () => {
        if (isHandleBooking(business) === false) {
            return false;
        }

        const separate_zones_reservations = business.info.configurations.find(
            (conf) => conf.name === 'separate_zones_reservations',
        );
        const accept_anonymous_booking = business.info.configurations.find(
            (conf) => conf.name === 'accept_anonymous_booking',
        );
        const hide_display_bookings = business.info.configurations.find(
            (conf) => conf.name === 'hide_display_bookings',
        );

        if (hide_display_bookings && +hide_display_bookings.value === 1) {
            return false;
        }

        //https://trello.com/c/olm5cOXQ/3339-ajouter-deux-options-dans-back-sur-le-r%C3%A9glage-des-r%C3%A9servations
        if (
            isLoggued() === false &&
            (typeof accept_anonymous_booking === 'undefined' ||
                (accept_anonymous_booking &&
                    +accept_anonymous_booking.value === 0))
        ) {
            return false;
        }

        //https://trello.com/c/NswTYCs7/3340-mettre-en-place-le-nom-des-zones-dans-les-shortcodes-utilis%C3%A9s-dans-les-homeblocs-du-front
        if (
            separate_zones_reservations &&
            separate_zones_reservations.value &&
            +separate_zones_reservations.value === 1
        ) {
            const zones = business?.info?.showtime.filter(
                (o) => o.booking === 1,
            );

            return (
                <>
                    <style type="text/css">
                        {`
                      .MuiListItemIcon-root {
                          min-width: 36px;
                      }
                  `}
                    </style>

                    <a
                        onClick={(event) => {
                            event.preventDefault();
                            _redirect('booking');
                        }}
                    >
                        <ListItem button key="booking">
                            <ListItemIcon>
                                <ScheduleOutlinedIcon
                                    style={{ color: props.color }}
                                />
                            </ListItemIcon>
                            <ListItemText
                                style={{ color: props.color }}
                                primary={translateMsg(
                                    'webapp',
                                    'pwa_ui__reservation',
                                )}
                            />
                        </ListItem>
                    </a>
                    {zones.map((zone, index) => {
                        return (
                            <a
                                key={index}
                                onClick={(event) => {
                                    event.preventDefault();
                                    setState({ ...state, ['right']: false });
                                    setTimeout(() => {
                                        _redirect(`/booking/${zone.slug}`);
                                    }, 300);
                                }}
                            >
                                <ListItem
                                    button
                                    key={zone.id}
                                    style={{
                                        paddingLeft: 50,
                                    }}
                                >
                                    <ListItemText
                                        button
                                        style={{ color: props.color }}
                                        primary={getVenueName(zone, lang)}
                                    />
                                </ListItem>
                            </a>
                        );
                    })}
                </>
            );
        }

        return (
            <a
                onClick={(event) => {
                    event.preventDefault();
                    _redirect('booking');
                }}
            >
                <ListItem button key="booking">
                    <ListItemIcon>
                        <ScheduleOutlinedIcon style={{ color: props.color }} />
                    </ListItemIcon>
                    <ListItemText
                        style={{ color: props.color }}
                        primary={translateMsg('webapp', 'pwa_ui__reservation')}
                    />
                </ListItem>
            </a>
        );
    };

    const _getPageName = (item) => {
        if (item.business_page_id) {
            const match = business.pages.find(
                (o) => o.id === item.business_page_id,
            );
            if (match) {
                return match.name.val;
            }
        }
        return item.name;
    };

    const _getCustomColor = (field1, field2) => {
        if (y < -20) {
            return business.info[field2];
        }
        return business.info[field1];
    };

    const _isDisplayInfo = () => {
        if (isIterable(business?.payments) && business?.payments.length > 0) {
            return true;
        }

        if (isIterable(business?.services) && business?.services.length > 0) {
            return true;
        }

        if (
            isIterable(business?.speciality_foods) &&
            business?.speciality_foods.length > 0
        ) {
            return true;
        }

        return false;
    };

    const _displayItemPage = () => {
        const pages = business?.pages.filter((o) => +o.show_in_menu === 1);

        if (pages.length > 0) {
            return pages.map((page, index) => {
                return (
                    <a
                        key={index}
                        onClick={(event) => {
                            /*
                            event.preventDefault();
                            const slug = getPageSlug(page.name.val);
                            _redirect(`page/${page.uuid}/${slug}`);
                            */

                            if (page.type === 'url') {
                                window.open(page.url, '_blank');
                                return false;
                            }

                            const slug = getPageSlug(page.name.val);

                            if (['html', 'froala'].includes(page.type)) {
                                router.push(
                                    `/page/${page.uuid}/${slug}`,
                                    `/page/${page.uuid}/${slug}`,
                                    {
                                        locale: lang,
                                    },
                                );
                            }
                        }}
                    >
                        <ListItem
                            key={page.id}
                            style={{
                                paddingLeft: 15,
                            }}
                        >
                            <ListItemIcon></ListItemIcon>
                            <ListItemText
                                style={{ color: props.color }}
                                primary={page.name.val}
                            />
                        </ListItem>
                    </a>
                );
            });
        }
    };

    const _redirect = (item) => {
        setState({ ...state, ['right']: false });
        router.push(`/${lang}/${item}`, `/${lang}/${item}`, { locale: lang });
        window.scrollTo(0, 0);
    };

    const sideList = (side) => (
        <div
            id="mc_mainDrawer"
            role="presentation"
            onClick={toggleDrawer}
            onKeyDown={toggleDrawer}
            style={{
                backgroundColor: props.backgroundColor,
                flex: 1,
                width: 250,
                paddingTop:
                    headerHeight +
                    getHeaderSpecialInfoHeight(business, orders, router),
            }}
        >
            <List
                ref={(el) => {
                    if (el) {
                        el.style.setProperty(
                            'background-color',
                            props.backgroundColor,
                            'important',
                        );
                    }
                }}
            >
                <a
                    onClick={(event) => {
                        event.preventDefault();
                        _redirect('');
                    }}
                >
                    <ListItem button key="home">
                        <ListItemIcon>
                            <HomeIcon style={{ color: props.color }} />
                        </ListItemIcon>
                        <ListItemText
                            style={{ color: props.color }}
                            primary={translateMsg('webapp', 'pwa_ui__home')}
                        />
                    </ListItem>
                </a>
                {_displayItemMenu()}
                {_displayItemPage()}
                {isHandleContact(business) && (
                    <a
                        onClick={(event) => {
                            event.preventDefault();
                            _redirect('contact');
                        }}
                    >
                        <ListItem button key="contact">
                            <ListItemIcon>
                                <ContactMailIcon
                                    style={{ color: props.color }}
                                />
                            </ListItemIcon>
                            <ListItemText
                                style={{ color: props.color }}
                                primary={translateMsg(
                                    'webapp',
                                    'pwa_ui__contact',
                                )}
                            />
                        </ListItem>
                    </a>
                )}

                {isHandleBooking(business) === false &&
                    typeof business.info.booking_url === 'string' &&
                    business.info.booking_url.length > 4 && (
                        <a
                            onClick={(event) => {
                                event.preventDefault();
                                document.location.href =
                                    business.info.booking_url;
                            }}
                        >
                            <ListItem button key="booking">
                                <ListItemIcon>
                                    <ScheduleOutlinedIcon
                                        style={{ color: props.color }}
                                    />
                                </ListItemIcon>
                                <ListItemText
                                    style={{ color: props.color }}
                                    primary={translateMsg(
                                        'webapp',
                                        'pwa_ui__reservation',
                                    )}
                                />
                            </ListItem>
                        </a>
                    )}

                {_displayItemBooking()}
                {_isDisplayInfo() === true && (
                    <a
                        onClick={(event) => {
                            event.preventDefault();
                            _redirect('information');
                        }}
                    >
                        <ListItem button key="information">
                            <ListItemIcon>
                                <InfoIcon style={{ color: props.color }} />
                            </ListItemIcon>
                            <ListItemText
                                style={{ color: props.color }}
                                primary={translateMsg(
                                    'webapp',
                                    'pwa_ui__infos',
                                )}
                            />
                        </ListItem>
                    </a>
                )}
                {isDisplayLanguages() === true && (
                    <React.Fragment>
                        <Divider />
                        <a
                            onClick={(event) => {
                                event.preventDefault();
                                _redirect('language');
                            }}
                        >
                            <ListItem button key="language">
                                <ListItemIcon>
                                    <FlagIcon style={{ color: props.color }} />
                                </ListItemIcon>
                                <ListItemText
                                    style={{ color: props.color }}
                                    primary={translateMsg(
                                        'webapp',
                                        'pwa_ui__languages',
                                    )}
                                />
                            </ListItem>
                        </a>
                    </React.Fragment>
                )}
                {isHandleRegime(business) === true && (
                    <a
                        onClick={(event) => {
                            event.preventDefault();
                            _redirect('regime');
                        }}
                    >
                        <ListItem button key="regime">
                            <ListItemIcon>
                                <AddCircleOutlineIcon
                                    style={{ color: props.color }}
                                />
                            </ListItemIcon>
                            <ListItemText
                                style={{ color: props.color }}
                                primary={translateMsg('webapp', 'pwa_ui__diet')}
                            />
                        </ListItem>
                    </a>
                )}
                {typeof business.info.hide_currency === 'number' &&
                    business.info.hide_currency === 0 &&
                    business.products.length > 0 &&
                    +business.info.handle_order === 1 && (
                        <a
                            onClick={(event) => {
                                event.preventDefault();
                                _redirect('currency');
                            }}
                        >
                            <ListItem button key="currency">
                                <ListItemIcon>
                                    <EuroIcon style={{ color: props.color }} />
                                </ListItemIcon>
                                <ListItemText
                                    style={{ color: props.color }}
                                    primary={translateMsg(
                                        'webapp',
                                        'pwa_ui__currency',
                                    )}
                                />
                            </ListItem>
                        </a>
                    )}
                {document &&
                    document.location &&
                    document.location.host &&
                    (document.location.host.includes('foound.in') ||
                        document.location.host.includes('localhost') ||
                        document.location.host.includes('menuchic.net')) && (
                        <a
                            onClick={(event) => {
                                event.preventDefault();
                                const bb = localStorage.getItem('babel');
                                if (bb) {
                                    localStorage.removeItem('babel');
                                } else {
                                    localStorage.setItem('babel', 'on');
                                }
                                document.location.href = `/${lang}`;
                            }}
                        >
                            <ListItem button key="babelkey">
                                <ListItemIcon></ListItemIcon>
                                <ListItemText
                                    style={{ color: props.color }}
                                    primary={
                                        localStorage.getItem('babel')
                                            ? 'hide babel key'
                                            : 'show babel key'
                                    }
                                />
                            </ListItem>
                        </a>
                    )}

                {isInApp() === false && (
                    <List
                        ref={(el) => {
                            if (el) {
                                el.style.setProperty(
                                    'background-color',
                                    props.backgroundColor,
                                    'important',
                                );
                            }
                        }}
                    >
                        {isLoggued() === true ? (
                            <React.Fragment>
                                <Divider />
                                <div>
                                    <a
                                        onClick={(event) => {
                                            event.preventDefault();
                                            _redirect('account');
                                        }}
                                    >
                                        <ListItem button key="account">
                                            <ListItemIcon>
                                                <PersonIcon
                                                    style={{
                                                        color: props.color,
                                                    }}
                                                />
                                            </ListItemIcon>
                                            <ListItemText
                                                style={{
                                                    color: props.color,
                                                }}
                                                primary={translateMsg(
                                                    'webapp',
                                                    'pwa_ui__account',
                                                )}
                                            />
                                        </ListItem>
                                    </a>
                                    <a
                                        onClick={(event) => {
                                            event.preventDefault();
                                            _redirect('account/messages');
                                        }}
                                    >
                                        <ListItem button key="account">
                                            <ListItemIcon>
                                                <ChatBubbleOutlineOutlinedIcon
                                                    style={{
                                                        color: props.color,
                                                    }}
                                                />
                                            </ListItemIcon>
                                            <ListItemText
                                                style={{
                                                    color: props.color,
                                                }}
                                                primary={translateMsg(
                                                    'webapp',
                                                    'pwa_ui__mymessages',
                                                )}
                                            />
                                        </ListItem>
                                    </a>
                                    {+business.info.handle_order === 1 && (
                                        <a
                                            onClick={(event) => {
                                                event.preventDefault();
                                                _redirect('account/orders');
                                            }}
                                        >
                                            <ListItem button key="account">
                                                <ListItemIcon>
                                                    <ReceiptIcon
                                                        style={{
                                                            color: props.color,
                                                        }}
                                                    />
                                                </ListItemIcon>
                                                <ListItemText
                                                    style={{
                                                        color: props.color,
                                                    }}
                                                    primary={translateMsg(
                                                        'webapp',
                                                        'pwa_ui__my_orders',
                                                    )}
                                                />
                                            </ListItem>
                                        </a>
                                    )}

                                    {isHandleBooking(business) === true && (
                                        <a
                                            onClick={(event) => {
                                                event.preventDefault();
                                                _redirect('account/bookings');
                                            }}
                                        >
                                            <ListItem button key="booking">
                                                <ListItemIcon>
                                                    <CalendarTodayIcon
                                                        style={{
                                                            color: props.color,
                                                        }}
                                                    />
                                                </ListItemIcon>
                                                <ListItemText
                                                    style={{
                                                        color: props.color,
                                                    }}
                                                    primary={translateMsg(
                                                        'webapp',
                                                        'pwa_ui__my_reservations',
                                                    )}
                                                />
                                            </ListItem>
                                        </a>
                                    )}
                                    <ListItem
                                        button
                                        key="LOGOUT"
                                        onClick={(event) => {
                                            event.preventDefault();
                                            dispatch(actions.logout());
                                        }}
                                    >
                                        <ListItemIcon>
                                            <ExitToAppIcon
                                                style={{
                                                    color: props.color,
                                                }}
                                            />
                                        </ListItemIcon>
                                        <ListItemText
                                            style={{
                                                color: props.color,
                                            }}
                                            primary={translateMsg(
                                                'webapp',
                                                'pwa_ui__logout',
                                            )}
                                        />
                                    </ListItem>
                                </div>
                            </React.Fragment>
                        ) : (
                            <React.Fragment>
                                <Divider />
                                <a
                                    onClick={(event) => {
                                        event.preventDefault();
                                        _redirect('login?from=d');
                                    }}
                                >
                                    <ListItem button key="login">
                                        <ListItemIcon>
                                            <PersonIcon
                                                style={{
                                                    color: props.color,
                                                }}
                                            />
                                        </ListItemIcon>
                                        <ListItemText
                                            style={{
                                                color: props.color,
                                            }}
                                            primary={translateMsg(
                                                'webapp',
                                                'pwa_ui__signin',
                                            )}
                                        />
                                    </ListItem>
                                </a>
                            </React.Fragment>
                        )}
                    </List>
                )}
            </List>
        </div>
    );

    if (
        +business.info.handle_multilang === 0 &&
        isHandleBooking(business) === false &&
        +business.info.handle_order === 0 &&
        +business.info.handle_menu === 0 &&
        isHandleRegime(business) === false &&
        typeof business.info.contact_email !== 'string'
    ) {
        return false;
    }

    return (
        <>
            <style type="text/css">
                {`

          
          @media only screen and (max-width: 768px) {

            .MuiDrawer-paper .MuiListItem-root:hover {
                background-color: transparent !important;
            }
          }

          @media only screen and (min-width: 768px) {

            .MuiDrawer-paper .MuiListItem-root:hover {
                background-color: ${props.bgm} !important;
            }

            .MuiDrawer-paper .MuiListItem-root:hover .MuiTypography-root {
                color: ${props.colorHover} !important;
            }

            .MuiDrawer-paper .MuiListItem-root:hover .MuiSvgIcon-root {
                color: ${props.colorHover} !important;
            }
          }
            `}
            </style>
            <div
                style={{
                    justifyContent: 'center',
                    display: 'flex',
                    flexDirection: 'column',
                    cursor: 'pointer',
                    paddingLeft: 5,
                    paddingRight: isMobile === false ? 6 : 0,
                }}
                onClick={toggleDrawer}
            >
                <MenuIcon style={{ color: props.iconColor, fontSize: 30 }} />
            </div>

            <Drawer
                //variant="permanent"
                variant="temporary"
                anchor="right"
                open={status}
                onClose={toggleDrawer}
                ModalProps={{
                    keepMounted: true, // Better open performance on mobile.
                }}
            >
                {sideList('right')}
            </Drawer>
        </>
    );
}

export default App;
